import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PaymentEffects } from './payment.effects';
import * as fromPayment from './payment.reducer';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromPayment.paymentFeatureKey, fromPayment.reducers, {
            metaReducers: fromPayment.metaReducers,
        }),
        EffectsModule.forFeature([PaymentEffects]),
    ],
})
export class PaymentModule {}

export * as PaymentActions from './payment.actions';
export * as PaymentSelectors from './payment.selectors';
